import { useEffect, useState } from 'react'
import Wrapper from '../styles/Wrapper'
import API from '../../../api/axios';
import { APP_URLS } from '../../../api/url';
import { toast } from 'react-toastify';
import { APIError, downloadFileError, getUserName, showUserTypeBadge } from '../../../core/utils';
import RecordCount from '../../../assets/SharedComponents/RecordCount/RecordCount';
import { Tooltip } from '@mui/material';
import { FaFilterIcon } from '../../../assets/Images/icon';
import UserFilter from '../../../assets/SharedComponents/Filters/UserFilter';
import SubsidiaryFilter from '../../../assets/SharedComponents/Filters/SubsidiaryFilter';
import VatInput from '../../../assets/SharedComponents/Filters/VatInput';
import { ThreeDots } from 'react-loader-spinner';
import NoRecord from '../../../assets/SharedComponents/Table/NoRecord';
import moment from 'moment';
import ExtractReport from '../../../assets/SharedComponents/ExtractReport/ExtractReport';
import download from 'downloadjs';
import ViewSummary from './Components/ViewSummary';
import Pagination from '../../../assets/SharedComponents/Pagination';
import ToggleButton from '../../../assets/SharedComponents/Filters/ToggleButton';

const VATVIESLogs = () => {

    const [logsList, _logsList] = useState([])

    const [pagintation, _pagintation] = useState({
        currentPage: 1,
        totalPages: 0,
        totalRecords: 0,
        RecordsPerPage: 10,
    });

    const [filters, _filters] = useState({
        is_valid: "",
        date_from: "",
        date_to: "",
        country_code: "",
        vat_number: "",
        user_id: "",
        sub_id: "",
        is_archived: "",
    });

    const [isLoading, _isLoading] = useState({
        logs: false,
        extractLogsReport: false,
        extractLogsSummary: false,
    })

    const [resetFilters, _resetFilters] = useState(false);
    const [refetchApi, _refetchApi] = useState()


    useEffect(() => {
        getVatAuditLogs();
    }, [pagintation.currentPage, pagintation.RecordsPerPage, filters, refetchApi]);

    const getFilters = () => {

        const params = new URLSearchParams({
            page: pagintation.currentPage,
            per_page: pagintation.RecordsPerPage,
        });

        if (filters.is_valid) params.append("filter[is_valid]", filters.is_valid);
        if (filters.date_from) params.append("filter[date_from]", filters.date_from);
        if (filters.date_to) params.append("filter[date_to]", filters.date_to);
        if (filters.country_code) params.append("filter[country_code]", filters.country_code);
        if (filters.vat_number) params.append("filter[vat_number]", filters.vat_number);
        if (filters.is_archived) params.append("filter[is_archived]", filters.is_archived);
        if (filters.user_id) params.append("filter[user_id]", filters.user_id);
        if (filters.sub_id) params.append("filter[sub_id]", filters.sub_id);

        return params.toString();
    }

    const handleLoader = (key, value) => {
        _isLoading((prev) => {
            return {
                ...prev,
                [key]: value
            }
        })
    }


    const getVatAuditLogs = () => {
        handleLoader('logs', true)
        API.get(`${APP_URLS.VAT_AUDIT_LOGS}?${getFilters()}`)
            .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                    _logsList(resp.data.data);
                    _pagintation((prev) => ({
                        ...prev,
                        totalPages: resp.data.last_page,
                        totalRecords: resp.data.total,
                    }));
                } else {
                    toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
                }
            })
            .catch((error) => {
                let error_message = APIError(error);
                toast.error(error_message, { position: toast.POSITION.TOP_RIGHT });
            })
            .finally(() => {
                handleLoader('logs', false)
            });
    };

    const handleExtractReport = () => {
        handleLoader('extractLogsReport', true)
        API.get(
            `${APP_URLS.EXPORT_VAT_AUDIT_LOGS}?${getFilters()}`,
            { responseType: "blob" }
        )
            .then((res) => {
                const resp = res.data;
                if (resp !== null) {
                    toast.success("Downloading. Please wait", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    const content = res.headers["content-type"];
                    const currentDate = moment().format("YYYY-MM-DD HH-mm-ss");
                    const fileName = `${currentDate}_vat_audit_logs_report.pdf`;
                    download(resp, fileName, content);
                } else {
                    toast.error(resp.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
            .catch(async function (error) {
                let error_message = await downloadFileError(error);
                toast.error(error_message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }).finally(() => {
                handleLoader('extractLogsReport', false)
            })
            ;
    }

    const handleExtractSummary = () => {
        handleLoader('extractLogsSummary', true)
        API.get(
            `${APP_URLS.EXPORT_VAT_AUDIT_LOGS_STATS}`,
            { responseType: "blob" }
        )
            .then((res) => {
                const resp = res.data;
                if (resp !== null) {
                    toast.success("Downloading. Please wait", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    const content = res.headers["content-type"];
                    const currentDate = moment().format("YYYY-MM-DD HH-mm-ss");
                    const fileName = `${currentDate}_vat_audit_logs_summary_report.pdf`;
                    download(resp, fileName, content);
                } else {
                    toast.error(resp.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
            .catch(async function (error) {
                let error_message = await downloadFileError(error);
                toast.error(error_message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }).finally(() => {
                handleLoader('extractLogsSummary', false)
            })
            ;
    }

    const handleFilterChange = (key, value) => {
        _filters((prev) => ({ ...prev, [key]: value }));
        _pagintation((prev) => ({ ...prev, currentPage: 1, totalPages: 0 }));
    };

    const clearFilter = () => {
        _filters({
            is_valid: "",
            date_from: "",
            date_to: "",
            country_code: "",
            vat_number: "",
            user_id: "",
            sub_id: "",
            is_archived: "",
        });
        _pagintation((prev) => ({ ...prev, currentPage: 1, totalPages: 0, RecordsPerPage: 10 }));
        _resetFilters(true)
    };

    return (
        <Wrapper>
            <h1>VAT Audit Logs</h1>
            <div className='filters'>
                <input
                    type={filters.date_from ? "date" : "text"}
                    placeholder="Start Date"
                    value={filters.date_from}
                    max={filters.date_to || new Date().toISOString().split("T")[0]}
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => !filters.date_from && (e.target.type = "text")}
                    onChange={(e) => handleFilterChange("date_from", e.target.value)}
                    className="datefilter"
                />
                <input
                    type={filters.date_to ? "date" : "text"}
                    placeholder="End Date"
                    value={filters.date_to}
                    min={filters.date_from}
                    max={new Date().toISOString().split("T")[0]}
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => !filters.date_to && (e.target.type = "text")}
                    onChange={(e) => handleFilterChange("date_to", e.target.value)}
                    className="datefilter"
                />
                <UserFilter
                    filters={resetFilters}
                    _filters={_resetFilters}
                    setUser={(val) => handleFilterChange('user_id', val)}
                    user={filters.user_id}
                />
                <SubsidiaryFilter
                    filters={resetFilters}
                    _filters={_resetFilters}
                    setSub={(val) => handleFilterChange('sub_id', val)}
                    sub={filters.sub_id}
                />
                <VatInput
                    countryCode={filters.country_code}
                    vatNumber={filters.vat_number}
                    handleCountry={(value) => handleFilterChange("country_code", value)}
                    handleVat={(val) => handleFilterChange('vat_number', val)}
                />
                <RecordCount
                    onSearchClick={(search) => _pagintation((prev) => ({ ...prev, RecordsPerPage: search }))}
                    val={pagintation.RecordsPerPage}
                    key={pagintation.RecordsPerPage}
                />

                <ToggleButton
                    title="Valid"
                    value={filters.is_valid}
                    onChange={() => {
                        handleFilterChange("is_valid", !filters.is_valid)
                    }}
                />

                <ToggleButton
                    title="Archived"
                    value={filters.is_archived}
                    onChange={() => {
                        handleFilterChange("is_archived", !filters.is_archived)
                    }}
                />

                <Tooltip title="Clear Filter" placement="bottom">
                    <FaFilterIcon className="filter-icon" role="button" onClick={clearFilter} />
                </Tooltip>
            </div>
            <div className='record-summary'>
                <div>
                    Total Records : <b>{pagintation.totalRecords}</b>
                </div>
                <div className='button-group'>
                    <ExtractReport
                        downloadFunction={handleExtractReport}
                        isLoading={isLoading.extractLogsReport}
                        styles="extract-report ml-2"
                        text=" Extract report"
                    />

                    <ViewSummary />

                    <ExtractReport
                        downloadFunction={handleExtractSummary}
                        isLoading={isLoading.extractLogsSummary}
                        styles="extract-report ml-2"
                        text=" Extract summary"
                    />
                </div>
            </div>
            <div className='tableContainer'>
                <table className='auctionTable'>
                    <thead className='tableHead'>
                        <tr className='table-row'>
                            <th>ID</th>
                            <th className='user-links'>User/Subsidiary</th>
                            <th>
                                VAT Number
                                <br />
                                (Country Code + Number)
                            </th>
                            <th>
                                Valid
                                <br />
                                Validated At
                            </th>
                            <th>
                                Archived
                                <br />
                                Archived At
                            </th>
                            <th>
                                Created At
                            </th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {isLoading.logs ?
                        <div className="d-flex justify-content-center three-dot">
                            <ThreeDots
                                height="150"
                                width="150"
                                radius="9"
                                color="#637df4"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClassName=""
                                visible={true}
                            />
                        </div> :
                        <tbody>
                            {logsList.length > 0 ?
                                logsList.map((log) => {
                                    const subsididary = log.subsidiaries_info?.[0]
                                    return (
                                        <tr className="table-row">
                                            <td>{log.id}</td>
                                            <td className='user-links'>
                                                <a
                                                    href={subsididary
                                                        ? `/company-details/${subsididary.id}`
                                                        : `/detail-member/${log.user_id}`
                                                    }
                                                    className="link"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <b>
                                                        {subsididary ? subsididary.name : getUserName(log.user)}
                                                        {showUserTypeBadge(subsididary ? 'subsidiary' : 'user')}
                                                    </b>
                                                </a>
                                            </td>
                                            <td>
                                                {log.country_code} {log.vat_number}
                                            </td>
                                            <td>
                                                <span className={`status ${log.validated_at ? 'status-active' : ''}`}></span>
                                                {log.validated_at ?
                                                    <>
                                                        <br />
                                                        {moment(log.validated_at)
                                                            .tz("Europe/Amsterdam")
                                                            .format("DD-MM-YYYY HH:mm")}
                                                    </>
                                                    : null
                                                }
                                            </td>
                                            <td>
                                                <span className={`status ${log.archived_at ? 'status-active' : ''}`}></span>
                                                {log.archived_at ?
                                                    <>
                                                        <br />
                                                        {moment(log.archived_at)
                                                            .tz("Europe/Amsterdam")
                                                            .format("DD-MM-YYYY HH:mm")}
                                                    </>
                                                    : null
                                                }
                                            </td>
                                            <td>
                                                {moment(log.created_at)
                                                    .tz("Europe/Amsterdam")
                                                    .format("DD-MM-YYYY HH:mm")}
                                            </td>
                                            <td>
                                                <a href={`/vat-audit-logs/${log.id}`} className='link' target='_blank'>
                                                    View
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                }) :
                                <NoRecord />
                            }
                        </tbody>
                    }
                </table>
            </div>

            {/* Pagination */}
            {pagintation.totalPages > 1 && (
                <Pagination
                    totalPages={pagintation.totalPages}
                    page={pagintation.currentPage}
                    key={pagintation.totalPages}
                    onPageClick={(page) => _pagintation((prev) => ({ ...prev, currentPage: page + 1 }))}
                />
            )}
        </Wrapper>
    )
}

export default VATVIESLogs